<template>
  <AppMobileTabBar
    v-if="enabled"
    :items="items"
  />
</template>

<script setup lang="ts">
const { enabledKeys } = useSiteModules()
const isPlatform = useState<boolean>('is-platform', () => true)
const enabled = computed(() => {
  if (isPlatform.value) return false
  return enabledKeys.value.has('healthRecord') || enabledKeys.value.has('onlineBooking')
})

const { data } = await useFetch<{ loggedIn: boolean }>('/api/patient/session', {
  default: () => ({ loggedIn: false }),
  immediate: enabled.value,
})

function dest(path: string) {
  if (data.value?.loggedIn) return path
  return `/patient/login?redirect=${encodeURIComponent(path)}`
}

const items = computed(() => [
  { label: 'خانه', icon: 'i-lucide-house', to: '/' },
  { label: 'نوبت‌های من', icon: 'i-lucide-calendar-days', to: dest('/patient/appointments') },
  { label: 'سوابق سلامت', icon: 'i-lucide-folder-heart', to: dest('/patient/health') },
  { label: 'حساب کاربری', icon: 'i-lucide-user-round', to: dest('/patient/profile') },
])
</script>
